export default __webpack_public_path__ + "static/media/Final_Bundle_Thumbnail.84dd14d8.png";